import odata from '@/core/api/mixin/odata'
import {odataCall} from "@/core/api/mixin/odata";
import rest from '@/core/api/mixin/rest'
import {apiClient} from "@/core/api/httpClient";

export const search = {
  ...odata('product-calls'),
  ...rest('product-calls'),
}

export const groupedReport = async(type, params) => {
  return odataCall(`product-calls-report/grouped/${type}`, params);
};

export const dateGrouped = async(type, params) => {
  return odataCall(`product-calls-report/date-report/${type}`, params);
};

export const clientSummary = async ($filter) => {
  const params = $filter ? { $filter } : {};
  return await apiClient.get(`product-calls-report/client-summary`, {
    params,
  });
};

export const productSummary = async ($filter) => {
  const params = $filter ? { $filter } : {};
  return await apiClient.get(`product-calls-report/product-summary`, {
    params,
  });
};
